<template>
  <div class="col-xl-6 col-md-6">
    <div class="card">
      <div class="card-header">
        <h5>Pagination</h5>
      </div>
      <div class="card-body pagination-padding">
        <nav aria-label="Page navigation example">
          <ul class="pagination pagination-primary">
            <li class="page-item"><a class="page-link" href="javascript:void(0)">Previous</a></li>
            <li class="page-item"><a class="page-link" href="javascript:void(0)">1</a></li>
            <li class="page-item"><a class="page-link" href="javascript:void(0)">2</a></li>
            <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
            <li class="page-item"><a class="page-link" href="javascript:void(0)">Next</a></li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>